// extracted by mini-css-extract-plugin
export var sectionadvices = "advicesBlock-module--sectionadvices--IaO3s";
export var title = "advicesBlock-module--title--EBU9F";
export var stepTitle = "advicesBlock-module--stepTitle--5uCRX";
export var stepSubtitle = "advicesBlock-module--stepSubtitle--14sV5";
export var steps = "advicesBlock-module--steps--u6CfW";
export var step = "advicesBlock-module--step--7-f8I";
export var stepText = "advicesBlock-module--stepText--XegZe";